module.exports = __webpack_public_path__ + "76bf5866691fcd4cf8f7b1eccd7152c4.pdf";